export default __webpack_public_path__ + "static/media/dove_blue.887610b4.png";